import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  scaleName: Yup.string().required("Scale name is required"),
  file: Yup.mixed().required("File is required"),
});
